import { walletApi } from '../api';

export const linkWalletToUser = async (
  walletAddress: string,
  walletSigned: string,
) => {
  try {
    await walletApi.connectWalletAndLinkUser({
      address: walletAddress,
      signedHash: walletSigned,
    });
  } catch (e) {
    window.Sentry?.captureException(e, {
      tags: {
        file: 'user-wallets.ts',
        function: 'linkWalletToUser',
      },
    });
  }
};
